// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjcIY97aBJ-rBn5I4CpY-JEHRzNxrzPwk",
  authDomain: "voc-squire.firebaseapp.com",
  projectId: "voc-squire",
  storageBucket: "voc-squire.appspot.com",
  messagingSenderId: "254096963133",
  appId: "1:254096963133:web:ed34f3ceb0d60702e41c54",
  measurementId: "G-VBSSZ6LD3R"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth(app);
